import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { ItemWithId } from '../../types/types';

interface SortableItemWrapperProps {
  item: ItemWithId;
  children: (props: {
    attributes: ReturnType<typeof useSortable>['attributes'];
    listeners: ReturnType<typeof useSortable>['listeners'];
  }) => React.ReactNode;
}

export const SortableItemWrapper: React.FC<SortableItemWrapperProps> = ({ item, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: String(item.id), // Convert number ID to string for dnd-kit
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
    zIndex: isDragging ? 1 : 'auto',
  };

  return <div ref={setNodeRef} style={style}>{children({ attributes, listeners })}</div>;
};